import { jsx } from "react/jsx-runtime";
import { createContext, useState, useContext } from "react";
const videoTimeDefault = {
  isAtLiveEdge: false,
  position: 0,
  seekableRange: {
    start: 0,
    end: 0
  },
  seekToLiveEdge: () => {
  }
};
const VideoTime = createContext(videoTimeDefault);
VideoTime.displayName = "VideoTime";
function useVideoTime() {
  const videoTime = useContext(VideoTime);
  if (!videoTime) {
    throw new Error("useVideoTime called without a VideoTime.Provider");
  }
  return videoTime;
}
const SetVideoTime = createContext(
  /** @type {SetVideoTimeContextState | undefined} */
  void 0
);
SetVideoTime.displayName = "SetVideoTime";
function useSetVideoTime() {
  const setVideoTime = useContext(SetVideoTime);
  if (!setVideoTime) {
    throw new Error("useSetVideoTime called without a SetVideoTime.Provider");
  }
  return setVideoTime;
}
function VideoTimeProvider({ children }) {
  const [videoTime, setVideoTime] = useState(videoTimeDefault);
  return /* @__PURE__ */jsx(SetVideoTime.Provider, { value: setVideoTime, children: /* @__PURE__ */jsx(VideoTime.Provider, { value: videoTime, children }) });
}
export {
  VideoTimeProvider,
  useSetVideoTime,
  useVideoTime };
//# sourceMappingURL=dist/components/VideoContextProvider/context/state/time.js.map